import { FC } from 'react';
import { Button, Form, Modal } from 'antd';
import close from '../../assets/RoundedClose.svg';

interface ModalProps {
    openModal: boolean;
    setOpenModal: React.Dispatch<React.SetStateAction<boolean>>;
}

export const ExistingScoreCard: FC<ModalProps> = ({ openModal, setOpenModal }) => {
    const [form] = Form.useForm();

    const handleFormSubmit = () => {
        form.validateFields()
            .then(() => {
                setOpenModal(false);
            })
            .catch((err) => console.log('err', err));
    };

    return (
        <>
            <Modal
                className="modal-modal"
                destroyOnClose
                centered
                open={openModal}
                onCancel={() => {
                    setOpenModal(false);
                }}
                closeIcon={<img src={close} />}
                footer={
                    <div style={{ display: 'flex', justifyItems: 'space-between', gap: '16px', width: '100%' }}>
                        <Button
                            block
                            key="back"
                            onClick={() => {
                                setOpenModal(false);
                            }}
                            className="cancel"
                        >
                            Cancel
                        </Button>
                        <Button block type="primary" onClick={handleFormSubmit}>
                            Submit New Evaluation
                        </Button>
                    </div>
                }
            >
                <div className="modal">
                    <div className="modal__header meeting" style={{ height: '88px' }}>
                        <div className="modal__title">Scorecard Already Submitted</div>
                    </div>

                    <div className="modal__main main" style={{ padding: '24px 56px 43px 56px' }}>
                        <p className="preferences-submitted__text">
                            A scorecard for NAME has already been submitted under the name NAME.
                        </p>
                        <p className="preferences-submitted__text" style={{ color: '#4D5E93' }}>
                            You may resubmit the scorecard. Your previous submission will be replaced.
                        </p>
                    </div>
                </div>
            </Modal>
        </>
    );
};
